import api from 'api';
import { useEffect, useRef, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import logo from '../images/logo-horizontal.png';
import { useNavigate } from 'react-router-dom';

const SalesInfoPix = () => {
  const { uuidSaleItem } = useParams();
  const [pixData, setPixData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  const fetchData = () => {
    api
      .get(`sales/pix/info/${uuidSaleItem}`)
      .then((r) => setPixData(r.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    let intervalId = null;

    if (pixData) {
      intervalId = setInterval(() => {
        checkPixStatus();
      }, 15 * 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [pixData]);

  const checkPixStatus = () => {
    if (pixData && uuidSaleItem) {
      let fields = {
        sale_id: uuidSaleItem,
      };

      api.post('/sales/pix/status', fields).then((r) => {
        if (r.data.status === 'expired') {
          setPixData(null);
        }
        if (r.data.status === 'confirmed') {
          setPaymentStatus(true);
          redirect();
        }
      });
    }
  };

  const redirect = async () => {
    setTimeout(() => {
      if (pixData.upsell_url) {
        window.location = pixData.upsell_url;
      } else {
        navigate(`/compra-realizada/${uuidSaleItem}`);
      }
    }, 5000);
  };

  const copyToClipboard = (e) => {
    e.preventDefault();
    ref.current.select();
    navigator.clipboard.writeText(pixData.qrcode);

    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <div id='wrap-info-pix'>
      <div className='info-pix'>
        <Row>
          <Col md={12}>
            <div className='modal-pix'>
              <div className='qr-code'>
                {pixData && (
                  <>
                    <img
                      src={'data:image/png;base64, ' + pixData.base64_qrcode}
                      className='img-fluid'
                      style={{ border: '1px solid #eee' }}
                    />
                    <textarea
                      id='pix-code'
                      className='form-control pix-code'
                      defaultValue={pixData.qrcode}
                      onClick={copyToClipboard}
                      ref={ref}
                      readOnly
                    />
                  </>
                )}

                <Button
                  size='sm'
                  onClick={copyToClipboard}
                  variant={!copied ? 'primary' : 'success'}
                >
                  {!copied ? (
                    <>
                      <i className='la la-copy mr-2' /> Copiar código PIX
                    </>
                  ) : (
                    'Copiado! :)'
                  )}
                </Button>
                {!paymentStatus ? (
                  <div className='waiting-payment'>
                    <i className='la la-circle-notch la-spin mr-2' />
                    <span>Aguardando pagamento...</span>
                  </div>
                ) : (
                  <div className='payment-confirmed'>
                    <i className='la la-check mr-2' />
                    <span>Pagamento confirmado!</span>
                  </div>
                )}
              </div>
              <div className='summary'>
                <div className='instructions-title'>Instruções</div>
                <div className='instructions-text'>
                  <span>
                    Use o app do seu banco selecionando a opção PIX e escaneie o
                    código para pagamento ou copie e cole o código. Pix tem
                    liberação imediata!
                  </span>
                  <div className='sub'>
                    Não feche esta página após pagar, aguarde a confirmação de
                    pagamento.
                  </div>
                </div>
              </div>
            </div>
            <div className='logo'>
              <img src={logo} alt='' />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SalesInfoPix;
